import styles from './style.module.scss';
import { Descriptions, Spin } from 'antd';
import { Button, PageHeader } from 'components';
import { Link, useLocation, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { EditIcon } from 'icons';

import useVacancyLanguages from '../useVacancyLanguages';

const Single = () => {
  const { t } = useTranslation();
  let [searchParams] = useSearchParams();
  const { pathname } = useLocation();

  const { singleItem } = useVacancyLanguages(false);

  const isSuccessUpdatePage = searchParams.get('success') === 'true';

  const title = isSuccessUpdatePage
    ? t('Lingue WAS SUCCESSFULLY UPDATED.')
    : t('Lingue');

  return (
    <div>
      <PageHeader title={title}>
        <Link to={`${pathname}/edit`}>
          <Button type={'secondary'} big iconMargin icon={<EditIcon />}>
            {t('MODIFICA')}
          </Button>
        </Link>
      </PageHeader>
      <div className={styles.content}>
        <Descriptions column={1} bordered>
          <Descriptions.Item label={t('Titolo')}>
            {singleItem?.title || <Spin size={'medium'} />}
          </Descriptions.Item>
        </Descriptions>
      </div>
    </div>
  );
};

export default Single;
